import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import NewsRepository from '@/repositories/newsRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useNewsDetailStore = defineStore({
    id: 'newsDetail',
    state: () => ({
        NoticeDt: '',
        NoticeSubject: '',
        NoticeMessage: '',
    }),
    getters: {},
    actions: {
        /**
         * お知らせ詳細取得API
         * @param {*} req
         * @returns response
         */
        async getNewsDetailAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const newsRepository = new NewsRepository();
            try {
                const response = await newsRepository.getNewsDetailApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                // ユーザー情報をstoreに格納
                this.NoticeDt = response.data.NoticeDt;
                this.NoticeSubject = response.data.NoticeSubject;
                this.NoticeMessage = response.data.NoticeMessage;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * お知らせ既読API
         * @param {*} requestBody
         * @returns response
         */
        async updateNewsDetailReadedAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const newsRepository = new NewsRepository();
            try {
                const response = await newsRepository.updateNewsReadedApi(API_URL, requestBody, idToken);
                return { success: true, reponceBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * お知らせ回答API
         * @param {*} requestBody
         * @returns response
         */
        async setNewsSelectedAnswerAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const newsRepository = new NewsRepository();
            try {
                const response = await newsRepository.updateNewsApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true, reponceBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
